import { loadScript } from '@/utils';

let paypalObject = null;
let sdkLoaded = false;

export default {
  // Load PayPal SDK once and return the paypal object
  async loadPaypalSDK({ clientId, merchantId }, currency) {
    if (!clientId || !merchantId) {
      throw new Error('Client ID and Merchant ID are required');
    }

    const widgetIframe = document.querySelector('iframe[name="double-checkout"]');

    // The checkout iframe is destroyed when the widget closes. Only reuse the
    // cached SDK when it belongs to the currently mounted iframe.
    if (sdkLoaded && paypalObject && paypalObject === widgetIframe.contentWindow.paypal) {
      return paypalObject;
    }

    const iframeHead = widgetIframe.contentDocument.head;

    try {
      await loadScript(
        `https://www.paypal.com/sdk/js?client-id=${clientId}&merchant-id=${merchantId}&enable-funding=venmo&components=buttons&currency=${currency.toUpperCase()}${
          process.env.NODE_ENV === 'development' ? '&buyer-country=US' : ''
        }`,
        {
          target: iframeHead,
          attributes: { 'data-partner-attribution-id': 'DoubleGivingInc_SP' }
        }
      );

      paypalObject = widgetIframe.contentWindow.paypal;

      if (!paypalObject) {
        throw new Error('PayPal SDK loaded but paypal object not found on window');
      }

      sdkLoaded = true;
      return paypalObject;
    } catch (error) {
      console.error('PayPal SDK loading failed:', error);
      sdkLoaded = false;
      paypalObject = null;
      throw error;
    }
  },

  // Render PayPal button
  async renderPayPalButton(paypal, callbacks, buttonElement) {
    return paypal
      .Buttons({
        style: {
          layout: 'vertical',
          color: 'gold',
          label: 'paypal',
          tagline: false,
          height: 48
        },
        fundingSource: paypal.FUNDING.PAYPAL,
        ...callbacks
      })
      .render(buttonElement);
  },

  // Render Venmo button
  async renderVenmoButton(paypal, callbacks, buttonElement) {
    // Check if Venmo is eligible before rendering
    // console.log(paypal.Buttons.canRenderTo);
    // const isVenmoEligible = paypal.Venmo().isEligible();
    // console.log(isVenmoEligible);

    // if (!isVenmoEligible) {
    //   return false;
    // }

    return paypal
      .Buttons({
        style: {
          layout: 'vertical',
          color: 'blue',
          // label: 'venmo',
          tagline: false,
          height: 48
        },
        fundingSource: paypal.FUNDING.VENMO,
        ...callbacks
        // onInit(data, actions) {
        //   console.log({ data, actions });

        //   // Check if Venmo is eligible and will be displayed
        //   console.log('actions.isFundingEligible', actions.isFundingEligible);
        //   if (actions.isFundingEligible('venmo')) {
        //     console.log('Venmo is eligible for display.');
        //   } else {
        //     console.log('Venmo is not eligible for display.');
        //   }
        // }
      })
      .render(buttonElement);
  },

  // Legacy method for backward compatibility
  async loadPaypal({ clientId, merchantId }, callbacks, buttonElement, currency) {
    const paypal = await this.loadPaypalSDK({ clientId, merchantId }, currency);
    await this.renderPayPalButton(paypal, callbacks, buttonElement);
    return paypal;
  }
};
